<div>
  <!-- Header -->
  <app-header></app-header>
  <!-- /Header -->

  <router-outlet></router-outlet>

  <!-- Footer -->
  <app-footer></app-footer>
  <!-- /Footer -->
</div>